export default "__VITE_ASSET__DUTIS_c4__"